<template>
  <section class="plan-row-item__wrapper">
    <template v-if="isRegularPlanCard">
      <div
        :class="[
          'plan-row-item plan-row-item--long',
          isBestValue && 'plan-row-item--best-value plan-row-item--best-value-square',
        ]"
        @click="updateSelectedPlan(plan)"
      >
        <div
          v-if="headerText"
          :class="['plan-row-item__header', isBestValue && 'plan-row-item__header--best-value']"
        >
          <div v-html="headerText" class="plan-row-item__header-text"></div>
        </div>
        <div class="plan-row-item__radio-wrapper">
          <RadioButton :isSelected="isSelected" />
        </div>
        <div class="plan-row-item__title">
          {{ normalizedPlanName }}
        </div>
        <PlanRowItemPrice :plan="plan" />
        <div class="plan-row-item__details">
          <PlanListItemDetails :plan="plan" />
        </div>
        <div class="plan-row-item__bottom-content" v-if="learnMoreLink">
          <div class="plan-row-item__learn-more" v-if="learnMoreLink">
            <a target="_blank" :href="learnMoreLink" class="plan-row-item__learn-more-link">
              See What's Included
            </a>
            <div class="plan-row-item__not-included" v-if="notIncluded">
              *Skill Dive Not Included
            </div>
          </div>
        </div>
        <div class="plan-row-item--best-value-square-bottom" v-if="isBestValue"></div>
      </div>
    </template>
    <template v-if="isBoogoCard">
      <div
        class="plan-row-item plan-row-item--best-value plan-row-item--best-value-square plan-row-item--padding-40"
        @click="updateSelectedPlan(plan)"
      >
        <div class="plan-row-item--best-value-square-top"></div>
        <div class="plan-row-item__radio-wrapper">
          <RadioButton :isSelected="isSelected" />
        </div>
        <div class="plan-row-item__title plan-row-item__title--boogo">
          {{ normalizedPlanName }}
          <BooGooLogo class="plan-row-item__title-boogo-img" />
        </div>
        <PlanRowItemPrice :plan="plan" />
        <div class="plan-row-item__details">
          <PlanListItemDetails :plan="plan" />
        </div>
        <div class="plan-row-item__bottom-content plan-row-item__bottom-content--boogo-card">
          <div class="plan-row-item__not-included">*Skill Dive Not Included</div>
        </div>
        <div class="plan-row-item--best-value-square-bottom"></div>
      </div>
    </template>
    <template v-if="isNeonPromoCard">
      <div
        :class="[
          'plan-row-item',
          isBestValue &&
            'plan-row-item--best-value plan-row-item--best-value-square plan-row-item--best-value-neon',
        ]"
        @click="updateSelectedBundle(plan)"
      >
        <div v-if="isBestValue" class="plan-row-item__neon-lights-wrapper-upper">
          <div class="plan-row-item__neon-lights-wrapper-lower">
            <div class="plan-row-item__neon-lights"></div>
          </div>
        </div>
        <div class="plan-row-item--best-value-square-top-border" v-if="isBestValue"></div>
        <div class="plan-row-item__radio-wrapper">
          <RadioButton :isSelected="isSelected" />
        </div>
        <PlanRowItemNeonCardPrice :itemIndex="index" :plan="plan" />
        <PlanRowItemNeonCardTitle :plan="plan" />
        <div class="plan-row-item__details">
          <PlanListItemDetails :plan="plan" />
        </div>
        <div class="plan-row-item__bottom-content plan-row-item__bottom-content--bottom-highlight">
          <div class="plan-row-item__learn-more plan-row-item__learn-more--justify-f-end">
            <div class="plan-row-item__not-included" v-if="notIncluded">
              *Skill Dive Not Included
            </div>
            <div class="plan-row-item__not-included" v-else></div>
          </div>
        </div>
        <div
          v-if="headerText"
          :class="[
            'plan-row-item__bottom-highlight',
            isBestValue && 'plan-row-item__bottom-highlight--best-value',
          ]"
        >
          <div v-html="headerText" class="plan-row-item__header-text"></div>
        </div>
        <div class="plan-row-item--best-value-square-bottom" v-if="isBestValue"></div>
      </div>
    </template>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { updateCart, priceDetailUpdates, routesRules } from '@/helpers/mixins'
import PlanListItemDetails from '@/components/plan-item-card/PlanListItemDetails.vue'
import PlanRowItemPrice from '@/components/plan-item-card/PlanRowItemPrice.vue'
import PlanRowItemNeonCardPrice from '@/components/plan-item-card/PlanRowItemNeonCardPrice.vue'
import PlanRowItemNeonCardTitle from '@/components/plan-item-card/PlanRowItemNeonCardTitle.vue'
import CONSTANTS from '@/constants'
import RadioButton from '@/components/shared/RadioButton.vue'

import BooGooTitle from '@/assets/images/hero-section/boogo/boogo_card_title.svg'

const { PLANS, PREMIUM_PLANS, LEAP_YEAR_PROMO_PRODUCT_BUNDLES } = CONSTANTS

export default {
  name: 'PlanRowItem',
  mixins: [updateCart, priceDetailUpdates, routesRules],
  props: {
    plan: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      isBoogoCard: this.plan.merchant_id === PLANS.INE_PREMIUM_BOOGO_2Y,
      notIncluded: [
        ...Object.values(PREMIUM_PLANS),
        ...Object.values(LEAP_YEAR_PROMO_PRODUCT_BUNDLES),
      ].includes(this.plan.merchant_id),
    }
  },
  components: {
    PlanListItemDetails,
    PlanRowItemPrice,
    RadioButton,
    BooGooLogo: { ...BooGooTitle, name: 'BooGooTitle' },
    PlanRowItemNeonCardPrice,
    PlanRowItemNeonCardTitle,
  },
  computed: {
    ...mapState({
      isPremiumMonthlyPromoActive: state => state.app.isPremiumMonthlyPromoActive,
    }),
    ...mapGetters({
      isLeapYearPromoActive: 'app/isLeapYearPromoActive',
      isBusinessUser: 'business/isBusinessUser',
    }),
    isSelected() {
      if ([...Object.values(LEAP_YEAR_PROMO_PRODUCT_BUNDLES)].includes(this.plan.merchant_id)) {
        return this.plan.merchant_id === this.selectedBundle.merchant_id
      }
      return this.plan.merchant_id === this.selectedPlan.merchant_id
    },
    isBestValue() {
      return this.plan.isBestValue
    },
    headerText() {
      let text = ''
      switch (this.plan.merchant_id) {
        case PLANS.MONTHLY:
          text = 'Introductory Content'
          break
        case PLANS.ANNUAL:
          text = this.isLeapYearPromoPage
            ? `<div class="plan-row-item__bottom-highlight">
              <div>Introductory Content <span class="plan-row-item__header-text--fundamentals-annual">Free eJPT and ICCA voucher</span></div>
              <div class="plan-row-item__bottom-highlight--you-save"><strong>YOU SAVE $100</strong></div>
            </div>`
            : 'Introductory Content <span class="plan-row-item__header-text--fundamentals-annual">Free eJPT and ICCA voucher</span>'
          break
        case PLANS.PREMIUM:
          text = 'Entire Content Library <strong>BEST VALUE</strong>'
          break
        case PLANS.BAH:
          text = 'Entire Content Library'
          break
        case LEAP_YEAR_PROMO_PRODUCT_BUNDLES.INE_LEAP_YEAR_BUNDLE:
          text =
            '<div class="plan-row-item__bottom-highlight--you-save"><strong>YOU SAVE $500</strong></div>'
          break
        default:
          text = false
          break
      }
      return text
    },
    learnMoreLink() {
      let link = ''
      switch (this.plan.merchant_id) {
        case PLANS.ANNUAL:
        case PLANS.MONTHLY:
          link = 'https://info.ine.com/fundamentals-faq/'
          break
        case PLANS.PREMIUM:
          link = 'https://info.ine.com/premium-faq/'
          break
        case PLANS.BAH:
          link = 'https://info.ine.com/bah/'
          break
        default:
          link = false
          break
      }
      return link
    },
    isFundamentalsAnnual() {
      return this.plan.merchant_id === PLANS.ANNUAL
    },
    normalizedPlanName() {
      if (this.isBoogoCard) return 'Premium'
      return this.plan.name
    },
    isRegularPlanCard() {
      return ![PLANS.INE_PREMIUM_BOOGO_2Y].includes(this.plan.merchant_id) && !this.isNeonPromoCard
    },
    isNeonPromoCard() {
      return this.isLeapYearPromoActive && this.isLeapYearPromoPage
    },
  },
}
</script>

<style lang="scss" scoped>
.plan-row-item {
  background: var(--mid-gray-gradient);
  border-radius: 10px;
  padding: 20px 40px;
  position: relative;
  cursor: pointer;
  transition: all 1s ease-out;
  width: 100%;
  &:hover {
    background: var(--mid-gray-translucid-gradient);
  }
  &:active {
    transition: all 0.5s ease-out;
    background: var(--charcoal-gradient-two);
  }
  @include desktop {
    max-width: 360px;
  }
  &--best-value {
    border-radius: 10px 10px 0 0;
    margin-bottom: 30px;
    @include mobile {
      border-radius: 10px;
      margin-bottom: unset;
    }
  }
  &--best-value-square {
    border-left: 10px solid #863ad2;
    border-right: 10px solid #5936e4;
    border-radius: 10px;
    &-top {
      position: absolute;
      top: 0;
      left: -5px;
      height: 10px;
      width: calc(100% + 10px);
      background: var(--purple-gradient);
      border-radius: 47px;
    }
    &-top-border,
    &-bottom {
      position: absolute;
      bottom: 0;
      left: -5px;
      height: 10px;
      width: calc(100% + 10px);
      background: var(--purple-gradient);
      border-radius: 47px;
    }
    &-top-border {
      top: 0;
    }
  }
  &--long {
    padding-top: 55px;
  }
  &--padding-40 {
    padding: 40px;
  }
  &__wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  &__header,
  &__bottom-highlight {
    position: absolute;
    top: 0;
    left: 0px;
    height: 35px;
    width: 100%;
    background: var(--mid-gray-translucid-gradient-four);
    border-radius: 10px 10px 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    &-text {
      color: var(--white);
      text-align: center;
      font-size: rem(12px);
      font-style: normal;
      font-weight: 450;
      line-height: rem(14px);
      display: flex;
      flex-flow: column;
      gap: 2px;
      @include tablet-ipad-air-and-mini-portrait {
        flex-flow: column;
      }
      @include tablet-ipad-pro {
        flex-flow: row;
      }
      @include desktop {
        flex-flow: row;
      }
    }
    &--best-value {
      background: var(--purple-gradient);
      left: -10px;
      width: calc(100% + 20px);
      .plan-row-item__header-text {
        display: block;
      }
    }
  }
  &__bottom-highlight {
    height: 70px;
    bottom: 0;
    top: unset;
    border-radius: 0 0 10px 10px;
    &--best-value {
      background: var(--purple-gradient);
    }
  }
  &__title {
    color: var(--white);
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    @include mobile {
      height: 70px;
    }
    @include desktop {
      height: unset;
    }
    &--boogo {
      display: flex;
      align-items: center;
      column-gap: 5px;
    }
  }
  &__bottom-content {
    margin-top: 30px;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    &--boogo-card {
      justify-content: flex-end;
    }
    &--bottom-highlight {
      height: 35px;
      margin-bottom: 70px;
    }
  }
  &__learn-more {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    white-space: nowrap;
    &-link {
      color: var(--purple-pale);
      font-size: rem(14px);
      font-style: normal;
      font-weight: 450;
      line-height: rem(20px);
      text-decoration: none;
    }
    &--justify-f-end {
      justify-content: flex-end;
    }
  }
  &__not-included {
    color: var(--light-blue-gray);
    font-size: rem(12px);
    font-style: italic;
    font-weight: 450;
    line-height: rem(14px);
    margin-bottom: 3px;
  }
  &__radio-wrapper {
    position: relative;
    left: 20px;
  }
  &__neon-lights {
    &-wrapper {
      &-upper {
        overflow: hidden;
        width: 100%;
        height: 300px;
        position: absolute;
        top: 0;
        left: 0;
      }
      &-lower {
        filter: blur(40px);
        position: absolute;
        background: linear-gradient(270deg, #196fc4 1%, #ff00e2 100%);
        background-repeat: no-repeat;
        top: 0;
        left: 0;
        width: 100%;
        height: 60%;
        border-radius: 0 0 50% 50%;
      }
    }
  }
}

::v-deep .plan-row-item__header-text--fundamentals-annual {
  color: var(--purple-pale);
  font-weight: 700;
}
::v-deep .plan-row-item__bottom-highlight--you-save {
  font-size: rem(16px);
  font-style: normal;
  font-weight: 700;
  line-height: rem(23px);
}
</style>
